import { SignIn, useAuth as useClerkAuth } from '@clerk/react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { user, loading, authError } = useAuth();
  const { isSignedIn } = useClerkAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (user) {
    if (user.role !== 'ADMIN') {
      if (!user.onboardingCompleted) return <Navigate to="/onboarding" replace />;
      if (user.status === 'PENDING') return <Navigate to="/pending" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  if (isSignedIn) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="text-center space-y-4">
          <p className="text-error text-sm">No se pudo cargar tu cuenta. Intenta de nuevo.</p>
          {authError ? <p className="text-muted-foreground text-xs">{authError}</p> : null}
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-md bg-primary text-on-primary text-sm font-semibold hover:bg-primary/90 transition-colors"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <SignIn routing="hash" forceRedirectUrl="/dashboard" />
    </div>
  );
}
